export default __webpack_public_path__ + "static/media/Pamela_Stone_AHV_In_Moms_We_Trust.50313dda.jpg";